export const BUTTON_VARIANTS = {
    CONTAINED: "contained",
    OUTLINED: "outlined",
    TEXT:'text',
}